<template>
  <div class="app-wrapper-frame">
    <div class="main-container">
      <div class="main-wrapper ccui-main-wrapper">
        <div class="iframeHeadWrap">
          <div class="iframeHeadLogo" :title="bidFuncName">
            <!--            <img :src="bidFlowLogo" />-->
            <img class="iframe-Logo" :src="bidLogo" />
            <div class="bidAppName">{{ bidAppName }}</div>
            <div class="bidFuncName">{{ bidFuncName }}</div>
          </div>
          <div class="iframeHeadMain">
            <el-row>
              <el-col :span="12"
                ><div class="iframeHeadMainLi" :title="form.schemeCode">
                  方案编号：{{ form.schemeCode }}
                </div></el-col
              >
              <el-col :span="12"
                ><div
                  class="iframeHeadMainLi"
                  :title="form.schemeName"
                  style="padding-right: 210px"
                >
                  方案名称：{{ form.schemeName }}
                </div></el-col
              >
              <el-col :span="12"
                ><div class="iframeHeadMainLi">
                  采购方式：{{ form.purchaseTypeName }}
                </div></el-col
              >
              <el-col :span="12"
                ><div class="iframeHeadMainLi" style="padding-right: 210px">
                  承办人：{{ form.purchaseUnderName }}
                </div></el-col
              >
            </el-row>
          </div>
          <div class="iframe_btn">
            <a
              href="javascript:;"
              style="margin-right: 20px"
              @click.prevent="handleReturnHome"
              ><svg-icon
                icon-class="returnWindow"
                class="window-icon-return"
              />返回桌面</a
            >
            <a href="javascript:;" @click.prevent="handleCloseWindow"
              ><svg-icon
                icon-class="closeWindow"
                class="window-icon-close"
              />关闭窗口</a
            >
          </div>
        </div>

        <div class="iframeBody">
          <div class="iframeMenu" style="width: 200px">
            <div class="iframeMenuWrap">
              <div class="iframeMenuTitle">
                {{
                  `在线${
                    purchaseType == 1 ||
                    purchaseType == 4 ||
                    purchaseType == 7 ||
                    purchaseType == 8
                      ? "评审"
                      : "评标"
                  }室`
                }}
              </div>
              <div class="iframeMenuCon">
                <el-tree
                  icon-class="el-icon-caret-right icon-position"
                  ref="tree"
                  :data="menuData"
                  :props="defaultProps"
                  node-key="menuKey"
                  :highlight-current="true"
                  @node-click="handleNodeClick"
                >
                </el-tree>
              </div>
            </div>
          </div>
          <div
            class="iframeMain iframeMainSub"
            style="margin-left: 200px; width: calc(100% - 230px)"
          >
            <div class="iframeMain-box">
              <app-main style="min-height: auto; margin-left: 0" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AppMain } from "./components";
// import bidFlowLogo from "@/basa/assets/images/expert-evaluate-flow-logo.png";
import {
  scpQueryPurchaseSchemeDetailApi,
  scpListBidEvaMenuApi,
  scpQryBidEvaProcessStatusApi,
  scpDealBidEvaCheckApi
} from "@/app/sourcingFlow/api/scp-expertEvaluation.js";
export default {
  name: "sourcingLayout",
  components: {
    AppMain
  },
  data() {
    return {
      // bidFlowLogo: bidFlowLogo,
      purchaseType: "",
      bidLogo:
        "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com/BASA_main/10000121987%40117158/2021/1/6/e3c4684543fa48379707a88c94a087f1.png",
      bidAppName: JSON.parse(sessionStorage.getItem("userDetal")).agentName,
      // bidFuncName: JSON.parse(sessionStorage.getItem("expertSourceData"))
      //   .opUnitName,
      bidFuncName: "常用功能",
      defaultProps: {
        children: "children",
        label: "label"
      },
      form: {},
      menuData1: [
        {
          label: "专家签到",
          menuKey: "001",
          routerName: "scpExpertsIn",
          leaf: true
        },
        {
          label: "承诺书确认",
          menuKey: "002",
          routerName: "scpLetterCommitmentConfirm",
          leaf: true
        },
        {
          label: "开标情况",
          menuKey: "003",
          routerName: "scpBidOpenSituation",
          leaf: true
        },
        {
          label: "评分表制定",
          menuKey: "004",
          routerName: "scpScoreScaleDeveloped",
          leaf: true
        },
        {
          label: "评分项查看",
          menuKey: "005",
          routerName: "scpViewScoreItems",
          leaf: true
        },
        {
          label: "分包商符合性检查",
          menuKey: "006",
          routerName: "scpSupplierComplianceInspection",
          leaf: true
        },
        {
          menuKey: "007",
          label: "分包商澄清",
          children: [
            {
              menuKey: "008",
              routerName: "scpIssueClarificationNotice",
              label: "发布澄清通知",
              leaf: true
            },
            {
              menuKey: "009",
              routerName: "scpSupplierClarificationLetter",
              label: "分包商澄清函",
              leaf: true
            }
          ]
        },
        {
          menuKey: "010",
          label: "专家评分",
          children: [
            {
              menuKey: "011",
              routerName: "scpSkiiScore",
              label: "技术评分",
              leaf: true
            },
            {
              menuKey: "012",
              routerName: "scpCommercialGrade",
              label: "商务评分",
              leaf: true
            },
            {
              menuKey: "013",
              routerName: "scpTechnicalScoreSummary",
              label: "技术评分汇总",
              leaf: true
            },
            {
              menuKey: "014",
              routerName: "scpSummaryBusinessSkillsScores",
              label: "商务技术评分汇总",
              leaf: true
            },
            {
              menuKey: "015",
              routerName: "scpTechnicalBusinessScore",
              label: "技术商务评分",
              leaf: true
            }
          ]
        },
        {
          menuKey: "016",
          label: "评标报告",
          children: [
            {
              menuKey: "017",
              label: "评标报告编制",
              routerName: "scpBidEvaluationReportPreparation",
              leaf: true
            },
            {
              menuKey: "018",
              label: "评标报告确认",
              routerName: "scpBidEvaluationReportConfirm",
              leaf: true
            }
          ]
        }
      ],
      menuData: [],
      indexUrl: "subSourcingFlow"
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      scpListBidEvaMenuApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        bidEvaId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .bidEvaId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        isShowPageLoading: true
      }).then(res => {
        // 临时解决问题注释，需要放开
        if (
          JSON.parse(sessionStorage.getItem("bidEvaPrepareDetailData"))
            .evaMethod === "103"
        ) {
          res.data.data.forEach(item => {
            if (item.label === "专家评分") {
              item.children.forEach(item1 => {
                if (item1.label === "商务技术评分汇总") {
                  item1.label = "商务评分汇总";
                }
              });
            }
          });
          this.menuData = res.data.data;
        } else {
          this.menuData = res.data.data;
        }
      });
      scpQueryPurchaseSchemeDetailApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        this.form = res.data.data;
        this.purchaseType = res.data.data.purchaseType;
        sessionStorage.setItem("purchaseType", res.data.data.purchaseType);
        sessionStorage.setItem(
          "moneyData",
          JSON.stringify({
            moneyTypeCode: res.data.data.moneyTypeCode,
            moneyTypeName: res.data.data.moneyTypeName,
            unit: res.data.data.unit
          })
        );
      });
    },
    handleNodeClick(obj) {
      if (
        obj.menuKey !== "0808" &&
        obj.menuKey !== "0806" &&
        obj.menuKey !== "0807"
      ) {
        // if (obj.menuKey === "080606"||obj.menuKey === "080608") {
        //   // 临时加if
        //   // 跳转路由
        //   this.$router.push({
        //     name: obj.routerName,
        //     query: {
        //       a: this.$router.history.current.query.a,
        //       menuKey: obj.menuKey
        //     }
        //   });
        // } else {
        scpDealBidEvaCheckApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .joinExpertId,
          stepCode: obj.menuKey,
          evaPurStep: obj.evaPurStep,
          isShowPageLoading: true
        })
          .then(res => {
            if (res.data.code == "0") {
              let joinId = JSON.parse(
                sessionStorage.getItem("expertSourceData")
              ).joinExpertId;
              if (obj.evaPurStep === "801" || obj.evaPurStep === "802") {
                joinId = obj.joinExpertId;
                sessionStorage.setItem("joinId", obj.joinExpertId);
              }
              let purStep =
                obj.routerName === "scpSupplierComplianceConfirm" ||
                obj.routerName === "scpSupplierComplianceInspection"
                  ? "0804"
                  : obj.menuKey;
              // if (
              //   this.$router.history.current.name ===
              //     "businessBidDetailConfirm" ||
              //   this.$router.history.current.name === "businessBidDetailEdit"
              // ) {
              //   purStep = "0811";
              // }
              scpQryBidEvaProcessStatusApi({
                isShowPageLoading: true,
                schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
                  .schemeId,
                evaPurStep: obj.evaPurStep,
                joinExpertId: joinId,
                purStep
              }).then(res => {
                sessionStorage.setItem(
                  "bidEvaProcessStatus",
                  JSON.stringify(res.data.data)
                );
                // 跳转路由
                this.$router.push({
                  name: obj.routerName,
                  query: {
                    a: this.$router.history.current.query.a,
                    evaPurStep: obj.evaPurStep,
                    menuKey:
                      obj.routerName === "scpSupplierComplianceInspection"
                        ? "0804"
                        : obj.menuKey
                  }
                });
              });
            } else {
              this.$router.push({
                name: this.indexUrl,
                query: {
                  a: this.$router.history.current.query.a,
                  evaPurStep: obj.evaPurStep,
                  menuKey: obj.menuKey
                }
              });
            }
          })
          .catch(res => {
            this.$router.push({
              name: this.indexUrl,
              query: {
                a: this.$router.history.current.query.a,
                evaPurStep: obj.evaPurStep,
                menuKey: obj.menuKey
              }
            });
          });
        // }
      }
    },
    handleReturnHome() {
      this.$router.push({
        name: this.indexUrl,
        query: {
          a: this.$router.history.current.query.a
        }
      });
    },
    handleCloseWindow() {
      window.parent.postMessage(false, "*");
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "~@/config/styles/mixin.scss";
@import "~@/config/styles/variables.scss";

html,
body {
  min-height: 100%;
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
.iframe_btn .window-icon-return {
  width: 18px;
  height: 18px;
  margin-right: 5px;
}
.iframe_btn .window-icon-close {
  margin-right: 5px;
}
</style>
<style rel="stylesheet/scss" lang="scss">
.no-print1 {
  display: none;
}
.iframeMenu {
  overflow: auto;
}
.iframeMenuCon {
  position: relative;
  padding-bottom: 20px;
}
.icon-position {
  position: relative;
  left: 130px;
}
.iframeMenuCon .el-tree-node__label {
  position: relative;
  left: -22px;
}
.icon-right {
  margin-right: 5px;
}
.iframe_btn {
  color: #ffffff;
  position: absolute;
  top: 15px;
  right: 20px;
  font-size: 14px;
}
</style>
